(function(){
  function pad(n){return (n<10?'0':'')+n}
  function tick(){
    var now=Date.now();
    document.querySelectorAll('[data-dr-cd]').forEach(function(el){
      var end=Date.parse(el.getAttribute('data-dr-cd'));
      if(isNaN(end)) return;
      var t=Math.max(0,Math.floor((end-now)/1000));
      if(t<=0 && !(window.Shopify && window.Shopify.designMode)){ el.classList.add('drc--fin'); return; }
      var v={d:Math.floor(t/86400),h:Math.floor(t%86400/3600),m:Math.floor(t%3600/60),s:t%60};
      el.querySelectorAll('[data-u]').forEach(function(b){ var k=b.getAttribute('data-u'); var txt=pad(v[k]); if(b.textContent!==txt) b.textContent=txt; });
      el.classList.toggle('drc--last', t<86400);
    });
  }
  tick(); setInterval(tick,1000);
})();
